import Mock from 'mockjs';
import './account';
import './menu';

Mock.setup({
  timeout: '200-600',
});
